import React from "react";

const NovelFrame = ({
  children,
  isFlipping,
  showLogo = false,
  isOpened = true,
  overlays,
}) => {
  return (
    <section className="novel-wrap">
      {showLogo && (
        <img
          src="/images/logo/magic4u-logo.svg"
          alt="로고"
          className="magic-logo"
        />
      )}
      <figure className="novel-asset1">
        <img src="/images/makingBranch/novel-light.svg" alt="novel-light" />
      </figure>
      <figure className="novel-asset2">
        <img src="/images/makingBranch/novel-light.svg" alt="novel-light" />
      </figure>

      {isOpened && (
        <>
          <div className="novel-inner">
            <div className="novel-frame">
              <div className="page-edge-left">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div className="inner-pages"></div>
              <div className="page-edge-right">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
            <div className="novel">{children}</div>
          </div>
          <figure className={`novel-left-hand ${isFlipping ? "flipping" : ""}`}>
            <img src="/images/makingBranch/left-hand.svg" alt="left-hand" />
          </figure>
          <figure
            className={`novel-right-hand ${isFlipping ? "flipping" : ""}`}
          >
            <img src="/images/makingBranch/right-hand.svg" alt="right-hand" />
          </figure>
        </>
      )}
      {!isOpened && children}
      {overlays}
    </section>
  );
};

export default NovelFrame;
